// Posts NOVOS (escritos à mão) — conteúdo original inspirado nos clusters de
// maior tráfego da concorrência, reescrito e melhorado. Cada post linka para a
// página de produto correspondente. Corpo em public/content/{slug}.html.
// Editável à mão (ao contrário de posts.js, que é gerado da migração).

export const postsExtra = [
  {
    id: 90014,
    slug: "reforma-tributaria-mercado-imobiliario-incorporadoras-loteadoras",
    title:
      "Reforma tributária no mercado imobiliário: o que muda para incorporadoras e loteadoras em 2026",
    date: "2026-09-23",
    excerpt:
      "IBS, CBS, redução de 50% de alíquota, RET e redutor de ajuste. Entenda, em linguagem direta, o que a reforma tributária muda para incorporadoras e loteadoras em 2026 — e como preparar a operação.",
    cover: "/wp-content/uploads/2026/09/reforma-tributaria-imobiliario.jpg",
    categories: [
      { name: "Economia", slug: "economia" },
      { name: "Vendas", slug: "vendas" },
    ],
    seoTitle: "Reforma tributária no mercado imobiliário 2026 | IMOBMEET",
    seoDesc:
      "Reforma tributária no imobiliário: IBS, CBS, redução de 50%, RET e o que muda para incorporadoras e loteadoras em 2026.",
    faq: [
      { q: "O que muda com a reforma tributária para o mercado imobiliário?", a: "PIS, Cofins, ISS e ICMS são substituídos por IBS e CBS (IVA dual). O setor imobiliário tem redução de 50% na alíquota da maioria das operações (nominal em torno de 13,25%) e 70% na locação, além de mecanismos como o redutor de ajuste e o regime do RET." },
      { q: "Qual a alíquota de IBS e CBS para imóveis?", a: "A alíquota padrão estimada é de cerca de 26,5%, mas com redução de 50% para operações imobiliárias chega a cerca de 13,25%. No RET (patrimônio de afetação), a alíquota unificada de IBS+CBS é de 2,08% (0,53% para residencial de interesse social)." },
      { q: "O que é o redutor de ajuste?", a: "É a possibilidade de deduzir da base de cálculo do IBS/CBS o valor de aquisição do imóvel (ou o valor de mercado em 31/12/2026) na hora da venda, evitando tributar a valorização ocorrida antes do novo sistema." },
      { q: "Quando a reforma tributária entra em vigor?", a: "2026 é ano de transição, com emissão de documentos fiscais de teste (0,9% de CBS e 0,1% de IBS) para validar sistemas. A cobrança cheia é implementada de forma gradual nos anos seguintes." },
    ],
  },
  {
    id: 90015,
    slug: "minha-casa-minha-vida-2026-o-que-muda",
    title:
      "Minha Casa Minha Vida 2026: novas faixas, teto e o que muda para incorporadoras",
    date: "2026-09-22",
    excerpt:
      "O MCMV 2026 ampliou faixas de renda até R$ 13 mil, subiu o teto do imóvel para R$ 600 mil e criou a modalidade Classe Média. Veja o que muda e como transformar a nova demanda em venda.",
    cover: "/wp-content/uploads/2026/09/minha-casa-minha-vida-2026.jpg",
    categories: [
      { name: "Economia", slug: "economia" },
      { name: "Lançamento imobiliário", slug: "lancamento-imobiliario" },
    ],
    seoTitle: "Minha Casa Minha Vida 2026: o que muda | IMOBMEET",
    seoDesc:
      "MCMV 2026: novas faixas de renda até R$ 13 mil, teto de R$ 600 mil e a modalidade Classe Média. O que muda para incorporadoras.",
    faq: [
      { q: "Quais são as faixas do Minha Casa Minha Vida 2026?", a: "Faixa 1: até R$ 3.200; Faixa 2: de R$ 3.200,01 a R$ 5.000; Faixa 3: de R$ 5.000,01 a R$ 9.600; e Faixa 4 (Classe Média): de R$ 9.600,01 a R$ 13.000 de renda familiar mensal." },
      { q: "Qual o teto do imóvel no MCMV 2026?", a: "O valor máximo do imóvel financiável subiu para até R$ 600 mil, conforme a localização e a renda. Nas Faixas 1 e 2, o valor costuma variar entre R$ 210 mil e R$ 275 mil." },
      { q: "O que é o MCMV Classe Média?", a: "É a nova modalidade que permite a participação de famílias com renda de até R$ 13 mil, ampliando o programa para um público que antes não tinha acesso às suas condições." },
      { q: "Como a incorporadora aproveita a ampliação do MCMV?", a: "Captando e qualificando os leads pela faixa de renda certa desde o primeiro contato, atendendo rápido e mantendo a esteira de documentos e crédito ágil até o contrato — com um CRM que conecta venda e financeiro." },
    ],
  },
  {
    id: 90016,
    slug: "reforma-tributaria-ret-patrimonio-de-afetacao-incorporadoras",
    title:
      "RET e patrimônio de afetação na reforma tributária: o que a incorporadora precisa saber em 2026",
    date: "2026-09-21",
    excerpt:
      "O RET foi preservado na reforma tributária, com alíquota unificada de 2,08% de IBS+CBS. Entenda o que muda no patrimônio de afetação e por que o controle por empreendimento fica ainda mais essencial.",
    cover: "/wp-content/uploads/2026/09/ret-patrimonio-afetacao.jpg",
    categories: [
      { name: "Economia", slug: "economia" },
      { name: "Lançamento imobiliário", slug: "lancamento-imobiliario" },
    ],
    seoTitle: "RET e patrimônio de afetação na reforma tributária | IMOBMEET",
    seoDesc:
      "RET e patrimônio de afetação na reforma tributária: alíquota unificada de 2,08% de IBS+CBS e o que muda para a incorporadora em 2026.",
    faq: [
      { q: "O que é RET e patrimônio de afetação?", a: "O patrimônio de afetação segrega o empreendimento do restante da incorporadora, protegendo terreno e recursos da obra. Sobre ele incide o RET (Regime Especial de Tributação), que unifica tributos em uma alíquota única sobre a receita." },
      { q: "Qual a alíquota do RET na reforma tributária?", a: "Pela LC 227/2026, a alíquota unificada de IBS+CBS no RET é de 2,08% sobre a receita recebida (0,53% para residencial de interesse social), mantendo 1,92% da receita mensal para IRPJ e CSLL." },
      { q: "O patrimônio de afetação continua valendo?", a: "Sim. O regime foi preservado na reforma e segue enxuto e previsível, protegendo comprador e obra e dando estabilidade para planejar o VGV e o caixa do empreendimento." },
      { q: "Por que controlar a operação por empreendimento?", a: "Porque o RET é por obra: é preciso enxergar receita recebida, parcelas, inadimplência e conciliação de cada empreendimento isoladamente. Um CRM com gestão de recebíveis por empreendimento entrega exatamente essa visão." },
    ],
  },
  {
    id: 90013,
    slug: "plataforma-crm-para-incorporadoras-guia-completo",
    title:
      "Plataforma CRM para incorporadoras: o guia completo para escolher, implantar e vender mais em 2026",
    date: "2026-09-23",
    excerpt:
      "Uma incorporadora não vende como uma imobiliária. Veja o que diferencia uma plataforma CRM para incorporadoras de um CRM genérico, as funcionalidades obrigatórias, 8 critérios de escolha e um checklist pronto para usar.",
    cover: "/assets/crm-para-incorporadoras-imobmeet.jpg",
    categories: [
      { name: "Vendas", slug: "vendas" },
      { name: "Tecnologia", slug: "tecnologia" },
    ],
    seoTitle:
      "Plataforma CRM para Incorporadoras: guia completo 2026 | IMOBMEET",
    seoDesc:
      "Guia completo de plataforma CRM para incorporadoras: o que é, funcionalidades essenciais, CRM + ERP e 8 critérios para escolher e vender mais em 2026.",
    faq: [
      { q: "Qual a diferença entre CRM imobiliário e CRM para incorporadoras?", a: "O CRM imobiliário tradicional foi pensado para imobiliárias que intermediam imóveis de terceiros. O CRM para incorporadoras gerencia estoque próprio de lançamentos, múltiplos canais de venda, contratos, repasse e carteira de recebíveis." },
      { q: "Um CRM para incorporadoras serve também para loteadoras?", a: "Serve, desde que a plataforma gerencie financiamento direto, parcelamento longo e cobrança recorrente, que são características centrais do loteamento." },
      { q: "Quanto tempo leva para implantar uma plataforma CRM em uma incorporadora?", a: "Depende do número de empreendimentos, de integrações e de usuários. Começar por um empreendimento-piloto reduz o prazo e o risco." },
      { q: "Posso trocar de CRM no meio de um lançamento?", a: "Pode, com planejamento da migração de dados (leads, histórico e contratos) e um período curto de operação em paralelo." },
      { q: "O CRM precisa se integrar ao ERP da incorporadora?", a: "Sim. Sem integração, vendas e financeiro trabalham com números diferentes, e a diretoria decide com dados atrasados." },
    ],
  },
  {
    id: 90010,
    slug: "o-que-e-sistema-para-loteamento",
    title: "O que é um sistema para loteamento e por que sua loteadora precisa de um",
    date: "2026-07-29",
    excerpt:
      "Sistema para loteamento é o software que reúne CRM, mapa de lotes e financeiro em um só lugar. Entenda o que ele faz, a diferença para um CRM genérico e por que sua loteadora precisa de um.",
    cover: "/wp-content/uploads/2025/06/loteamento-de-terrenos.jpg",
    categories: [
      { name: "Vendas", slug: "vendas" },
      { name: "Tecnologia", slug: "tecnologia" },
    ],
    seoTitle: "O que é um Sistema para Loteamento e por que você precisa | IMOBMEET",
    seoDesc:
      "O que é um sistema para loteamento, o que ele faz (mapa de lotes, CRM, recebíveis, comissões) e por que sua loteadora precisa de um software de gestão especializado.",
    faq: [
      { q: "O que é um sistema para loteamento?", a: "É o software que centraliza toda a operação de uma loteadora — vendas, mapa de lotes, reservas, propostas, contratos e recebíveis — em um só lugar. O IMOBMEET é um sistema para loteamento completo, do primeiro lead à última parcela paga." },
      { q: "Para que serve um sistema para loteamento?", a: "Serve para controlar as vendas e o financeiro do loteamento sem planilhas: evita venda em duplicidade com o mapa de lotes em tempo real, automatiza propostas e contratos e reduz a inadimplência com a régua de cobrança." },
      { q: "Qual a diferença entre um sistema para loteamento e um CRM genérico?", a: "Um CRM genérico organiza contatos, mas não entende lote, quadra, tabela de parcelas nem carteira de recebíveis. Um sistema para loteamento nasce falando essa língua e integra vendas e financeiro em uma só plataforma." },
      { q: "Qual o melhor sistema para loteamento?", a: "O melhor sistema para loteamento é o que une CRM e financeiro em uma plataforma só, com mapa de lotes em tempo real, gestão de recebíveis e integração com ERPs. O IMOBMEET reúne tudo isso, com implantação acompanhada em 4 a 6 semanas." },
    ],
  },
  {
    id: 90011,
    slug: "software-para-loteamento-como-escolher",
    title: "Software para loteamento: como escolher o ideal para a sua loteadora",
    date: "2026-07-28",
    excerpt:
      "Escolher o software para loteamento errado custa caro. Veja os 7 critérios que separam um bom sistema de gestão de loteamento de um que só atrapalha o seu time.",
    cover: "/wp-content/uploads/2025/05/Tela-disponibilidade-lotes-e-apartamentos-001.png",
    categories: [
      { name: "Vendas", slug: "vendas" },
      { name: "Tecnologia", slug: "tecnologia" },
    ],
    seoTitle: "Software para Loteamento: como escolher o ideal | IMOBMEET",
    seoDesc:
      "Como escolher um software para loteamento: 7 critérios essenciais — mapa de lotes, CRM, financeiro integrado, split de comissões, integrações, usabilidade e suporte.",
    faq: [
      { q: "Como escolher um software para loteamento?", a: "Avalie se ele é especializado em loteamento (entende lote, quadra e parcelas), se tem mapa de lotes em tempo real, se une vendas e financeiro, se automatiza comissões, se integra com portais e ERPs, se é fácil de usar e como são o suporte e a implantação." },
      { q: "O que um bom software para loteamento precisa ter?", a: "Mapa de lotes em tempo real, CRM de leads, gestão de reservas, propostas e contratos, emissão de boletos, régua de cobrança e split de comissões — tudo integrado em uma única plataforma." },
      { q: "Vale a pena um software específico para loteamento?", a: "Sim. Ferramentas genéricas geram retrabalho e inadimplência sem controle. Um sistema feito para loteamento evita venda em duplicidade e dá previsibilidade de caixa à loteadora." },
      { q: "Quanto custa um software para loteamento?", a: "O investimento varia conforme o tamanho da carteira, o número de empreendimentos e os módulos contratados. Agende uma demonstração do IMOBMEET para receber uma proposta sob medida." },
    ],
  },
  {
    id: 90012,
    slug: "como-reduzir-inadimplencia-no-loteamento",
    title: "Como reduzir a inadimplência no loteamento: 6 estratégias práticas",
    date: "2026-07-27",
    excerpt:
      "Carteira longa e cobrança no improviso transformam inadimplência em problema silencioso. Veja 6 estratégias para reduzir a inadimplência no loteamento com processo e sistema.",
    cover: "/wp-content/uploads/2026/09/reduzir-inadimplencia-loteamento.jpg",
    categories: [
      { name: "Vendas", slug: "vendas" },
      { name: "Economia", slug: "economia" },
    ],
    seoTitle: "Como Reduzir a Inadimplência no Loteamento: 6 estratégias | IMOBMEET",
    seoDesc:
      "6 estratégias práticas para reduzir a inadimplência no loteamento: carteira de recebíveis centralizada, régua de cobrança automática, boleto automático e mais.",
    faq: [
      { q: "Como reduzir a inadimplência no loteamento?", a: "Centralize a carteira de recebíveis, automatize a régua de cobrança por WhatsApp e e-mail, emita boletos automaticamente e aja rápido no primeiro atraso. Um sistema integrado ao CRM torna esse processo automático." },
      { q: "O que causa a inadimplência em loteamentos?", a: "O ciclo de pagamento longo e de baixo ticket mensal faz muita gente adiar o pagamento. Quando a cobrança depende de alguém lembrar de ligar, o atraso vira regra." },
      { q: "Como funciona a régua de cobrança automática?", a: "São lembretes automáticos antes do vencimento e avisos escalonados depois do atraso, por WhatsApp e e-mail. A cobrança preventiva evita a maior parte da inadimplência." },
      { q: "Um sistema ajuda a reduzir a inadimplência?", a: "Sim. Com boleto gerado automaticamente, 2ª via no WhatsApp, conciliação bancária e indicadores de inadimplência por safra, o caixa fica previsível. É o que o IMOBMEET entrega." },
    ],
  },
  {
    id: 90001,
    slug: "o-que-e-crm-imobiliario",
    title: "O que é CRM imobiliário e como escolher o ideal para a sua operação",
    date: "2026-07-25",
    excerpt:
      "CRM imobiliário é o sistema que organiza leads, atendimento, reservas e vendas em um só lugar. Entenda o que ele faz, por que um CRM genérico não resolve e como escolher a plataforma certa para incorporadoras e loteadoras.",
    cover: "/wp-content/uploads/2023/03/crm-de-vendas-imobiliario.jpeg",
    categories: [
      { name: "Vendas", slug: "vendas" },
      { name: "Tecnologia", slug: "tecnologia" },
    ],
    seoTitle: "O que é CRM Imobiliário: o guia para escolher o ideal | IMOBMEET",
    seoDesc:
      "Entenda o que é um CRM imobiliário, o que ele faz e como escolher a plataforma certa para incorporadoras e loteadoras venderem mais e gerenciarem melhor.",
  },
  {
    id: 90002,
    slug: "como-vender-lotes-encalhados",
    title: "Como vender lotes encalhados: 7 estratégias para acelerar o seu VGV",
    date: "2026-07-24",
    excerpt:
      "Estoque parado trava o caixa da loteadora. Veja estratégias práticas — de reprecificação inteligente a reengajamento de leads antigos com CRM — para girar lotes encalhados e recuperar VGV.",
    cover: "/wp-content/uploads/2026/09/vender-lotes-encalhados.jpg",
    categories: [
      { name: "Vendas", slug: "vendas" },
      { name: "Lançamento imobiliário", slug: "lancamento-imobiliario" },
    ],
    seoTitle: "Como Vender Lotes Encalhados: 7 Estratégias para o VGV | IMOBMEET",
    seoDesc:
      "Lotes parados no estoque? Veja 7 estratégias práticas para vender lotes encalhados, reengajar leads e acelerar o VGV da sua loteadora com CRM.",
  },
  {
    id: 90003,
    slug: "split-de-comissoes-imobiliario-como-funciona",
    title: "Split de comissões imobiliário: como funciona a pagadoria automática",
    date: "2026-07-23",
    excerpt:
      "Calcular e repassar comissão de corretor na mão gera erro, atraso e retrabalho. Entenda como o split de comissões automatiza o particionamento por venda e paga cada corretor via PIX, direto do CRM.",
    cover: "/wp-content/uploads/2026/09/split-comissoes-imobiliario.jpg",
    categories: [
      { name: "Vendas", slug: "vendas" },
      { name: "Tecnologia", slug: "tecnologia" },
    ],
    seoTitle: "Split de Comissões Imobiliário: como funciona a pagadoria | IMOBMEET",
    seoDesc:
      "Entenda como o split de comissões automatiza o cálculo e o repasse da comissão de corretores por venda, com pagamento via PIX integrado ao CRM imobiliário.",
  },
];
